import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const CalendarIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 12.804 12.804">
      <circle
        cx="0.5"
        cy="0.5"
        r="0.5"
        transform="translate(8.804 4.804)"
        fill={props.color || theme.palette.primary.main}
      />
      <path
        d="M10.8,1h-.65V.5a.5.5,0,1,0-1,0V1H6.877V.5a.5.5,0,0,0-1,0V1H3.626V.5a.5.5,0,0,0-1,0V1H2A2,2,0,0,0,0,3v7.8a2,2,0,0,0,2,2H5.827a.5.5,0,0,0,0-1H2a1,1,0,0,1-1-1V3A1,1,0,0,1,2,2h.625v.5a.5.5,0,0,0,1,0V2H5.877v.5a.5.5,0,0,0,1,0V2H9.153v.5a.5.5,0,1,0,1,0V2h.65a1,1,0,0,1,1,1V5.852a.5.5,0,0,0,1,0V3A2,2,0,0,0,10.8,1Z"
        fill={props.color || theme.palette.primary.main}
      />
      <path
        d="M273.026,270a3.026,3.026,0,1,0,3.026,3.026A3.029,3.029,0,0,0,273.026,270Zm0,5.051a2.026,2.026,0,1,1,2.026-2.026A2.028,2.028,0,0,1,273.026,275.051Z"
        transform="translate(-263.248 -263.248)"
        fill={props.color || theme.palette.primary.main}
      />
      <path
        d="M372.225,331.025H372V330.5a.5.5,0,1,0-1,0v1.025a.5.5,0,0,0,.5.5h.725a.5.5,0,1,0,0-1Z"
        transform="translate(-361.722 -321.748)"
        fill={props.color || theme.palette.primary.main}
      />
      <circle
        cx="0.5"
        cy="0.5"
        r="0.5"
        transform="translate(6.804 4.804)"
        fill={props.color || theme.palette.primary.main}
      />
      <circle
        cx="0.5"
        cy="0.5"
        r="0.5"
        transform="translate(4.804 6.804)"
        fill={props.color || theme.palette.primary.main}
      />
      <circle
        cx="0.5"
        cy="0.5"
        r="0.5"
        transform="translate(2.804 4.804)"
        fill={props.color || theme.palette.primary.main}
      />
      <circle
        cx="0.5"
        cy="0.5"
        r="0.5"
        transform="translate(2.804 6.804)"
        fill={props.color || theme.palette.primary.main}
      />
      <circle
        cx="0.5"
        cy="0.5"
        r="0.5"
        transform="translate(2.804 8.804)"
        fill={props.color || theme.palette.primary.main}
      />
      <circle
        cx="0.5"
        cy="0.5"
        r="0.5"
        transform="translate(4.804 8.804)"
        fill={props.color || theme.palette.primary.main}
      />
      <circle
        cx="0.5"
        cy="0.5"
        r="0.5"
        transform="translate(4.804 4.804)"
        fill={props.color || theme.palette.primary.main}
      />
    </SvgIcon>
  );
};
